import layout1 from "./layout-1";
import layout2 from "./layout-2";
import layout3 from "./layout-3";
import layout4 from "./layout-4";

export const layouts = [
    {
        label: "Layout 1",
        value: layout1,
    },
    {
        label: "Layout 2",
        value: layout2,
    },
    {
        label: "Layout 3",
        value: layout3,
    },
    {
        label: "Layout 4",
        value: layout4,
    },
];

export const themes = [
    {
        label: "Green",
        value: 'green',
    },
    {
        label: "Red",
        value: 'red',
    },
    {
        label: "Blue",
        value: 'blue',
    },
    {
        label: "Orange",
        value: 'orange',
    },
];
